import PropTypes from 'prop-types';
import TTSVoicePicker from './tts-voice-picker.jsx';
import { useMemo } from 'preact/hooks';

TTSPollOption.propTypes = {
  pollOption: PropTypes.object.isRequired,
  mapping: PropTypes.object.isRequired,
  onVoiceSelected: PropTypes.func,
};

export default function TTSPollOption({
  pollOption,
  mapping,
  onVoiceSelected,
}) {
  const { name, id } = pollOption;

  function handleSelection({ selectedVoice, selectedVoiceIndex }) {
    onVoiceSelected({ selectedVoice, selectedVoiceIndex, id: pollOption.id });
  }

  const currentVoiceName = useMemo(() => {
    return mapping[id];
  }, [mapping, id]);

  return (
    <div>
      <div className="mt-2 mb-4">
        <TTSVoicePicker
          label={
            <div className="flex justify-between items-center w-full">
              <span className="text-neutral">Option:</span>
              <span className="ml-1 font-bold">{name}</span>
            </div>
          }
          currentVoiceName={currentVoiceName}
          onVoiceSelected={handleSelection}
        />
      </div>
    </div>
  );
}
